import { VAN_STATUS } from "../van/VanSession"
import useVanSession from "../hooks/useVanSession"
import useOnlineStatus from "../hooks/useOnlineStatus"
import useCloseRequest from "../hooks/useCloseRequest"
import "./VanSheet.css"

const STATUS_LABEL = {
  [VAN_STATUS.IDLE]: "Starting…",
  [VAN_STATUS.CONNECTING]: "Connecting to VAN…",
  [VAN_STATUS.CONNECTED]: "Hold to ask",
  [VAN_STATUS.LISTENING]: "Listening…",
  [VAN_STATUS.THINKING]: "VAN is answering…",
  [VAN_STATUS.CLOSED]: "Session ended",
  [VAN_STATUS.ERROR]: "VAN unavailable"
}

const OFFLINE_LABEL = "VAN needs a connection"

// Voice panel mirroring the native VAN screen: one button toggles the turn,
// TAP TO SPEAK -> TAP TO STOP, as in VANWebRTCView.primaryButtonLabel.
export default function VanSheet({ item, onClose }) {
  const isOnline = useOnlineStatus()
  // The voice relay is network-only, so no session starts while offline.
  const { status, error, isVanSpeaking, startTurn, endTurn } = useVanSession({
    itemId: item.id,
    isOpen: isOnline
  })
  useCloseRequest(true, onClose)

  const isListening = status === VAN_STATUS.LISTENING
  // Tapping while VAN is answering barges in and starts a new turn, as the native
  // screen does (onPrimaryButtonTap treats .vanSpeaking like .idle).
  const canTalk =
    isOnline &&
    (isListening || status === VAN_STATUS.CONNECTED || status === VAN_STATUS.THINKING)

  return (
    <div className="van" role="dialog" aria-modal="true" aria-label={`Ask VAN about ${item.name}`}>
      <button type="button" className="van__close" aria-label="Close" onClick={onClose}>
        <img src="/img/close-x.png" alt="" aria-hidden="true" />
      </button>

      <div className="van__body">
        <p className="van__eyebrow">Practice</p>
        <h2 className="van__title">{item.name}</h2>

        <div
          className={`van__orb${isListening ? " van__orb--listening" : ""}${
            isVanSpeaking ? " van__orb--speaking" : ""
          }`}
          aria-hidden="true"
        >
          <span className="van__orb-glow" />
          <img
            className="van__orb-sphere"
            src={`/img/van/van-${isVanSpeaking ? "speaking" : "listening"}.webp`}
            alt=""
          />
        </div>

        <p className="van__status" role="status">
          {isOnline ? (error ?? STATUS_LABEL[status]) : OFFLINE_LABEL}
        </p>

        <button
          type="button"
          className={`van__talk${isListening ? " van__talk--live" : ""}`}
          disabled={!canTalk}
          onClick={isListening ? endTurn : startTurn}
        >
          {isListening ? "Tap to stop" : "Tap to speak"}
        </button>
      </div>
    </div>
  )
}
